import { useTranslate } from 'module/hooks/use-translation';
import { Select } from 'module/ui/components/atoms/select/select';
import { Option } from 'module/ui/components/atoms/select/types';
import { FC, useCallback, useMemo } from 'react';
import { components, OptionProps } from 'react-select';
import { fieldTypeAsOptions } from './utils';
import { FieldTypeWithIcon } from '../fields/field-types';
import { UiFieldType } from '../fields/types';

export const CustomOption = (
  props: OptionProps<Option<UiFieldType>, false>,
) => {
  const { data } = props;

  return (
    <components.Option {...props}>
      <span data-cy={`settings_field_type_${data.value}`}>
        <FieldTypeWithIcon fieldType={data.value} />
      </span>
    </components.Option>
  );
};
interface Props {
  value?: UiFieldType;
  onChange?: (next: UiFieldType) => void;
  isDisabled?: boolean;
}
export const FieldTypeSelect: FC<Props> = ({ value, onChange, isDisabled }) => {
  const translate = useTranslate();
  const fieldTypeOptions = useMemo(
    () => fieldTypeAsOptions(translate),
    [translate],
  );
  const selectedOption = useMemo(
    () => value != null && fieldTypeOptions.find((x) => x.value === value),
    [fieldTypeOptions, value],
  );
  const onTypeChange = useCallback(
    (option: Option<UiFieldType>) => {
      onChange?.(option.value);
    },
    [onChange],
  );

  return (
    <Select
      isClearable={false}
      isDisabled={isDisabled}
      options={fieldTypeOptions}
      value={selectedOption}
      onChange={onTypeChange}
      components={{ Option: CustomOption }}
    />
  );
};
